import styled from 'styled-components';

import { PlayerMetaDataSectionStyled } from '../PlayerMetaDataSection.Styles';
import { px } from '../../../../../../../../contrib/ui';

export const PlayerNotesStyled = styled(PlayerMetaDataSectionStyled)`
  .formcontrol-container {
    margin-top: ${px(-5)};

    legend {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: ${px(15)};

      .comment-icon {
        transform: scale(-1, 1);
        margin-right: ${px(10)};
      }
    }
  }
`;
